import React from 'react';

import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

import { useMapControls } from 'ff/debrief/hooks';

interface Props {}

const MapZoomControls: React.FC<Props> = props => {
    const { controls } = useMapControls();

    const handlePlusClick = () => {
        controls.zoomIn();
    };

    const handleMinusClick = () => {
        controls.zoomOut();
    };

    return (
        <Stack spacing="1px">
            <Paper
                sx={{
                    width: '32px',
                    padding: 0,
                    borderRadius: '4px 4px 0 0',
                }}
            >
                <IconButton size="small" onClick={handlePlusClick}>
                    <AddIcon sx={{ color: '#000000' }} />
                </IconButton>
            </Paper>
            <Paper
                sx={{
                    width: '32px',
                    padding: 0,
                    borderRadius: '0 0 4px 4px',
                }}
            >
                <IconButton size="small" onClick={handleMinusClick}>
                    <RemoveIcon sx={{ color: '#000000' }} />
                </IconButton>
            </Paper>
        </Stack>
    );
};

export default MapZoomControls;
